var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5243 0.0993558L1.22926 6.0369C0.827235 6.26783 0.878322 6.82739 1.27813 6.99614L3.63922 7.98647L10.0206 2.36424C10.1428 2.25543 10.316 2.42197 10.2116 2.54854L4.86086 9.06562V10.8531C4.86086 11.3771 5.49389 11.5836 5.80485 11.2039L7.21528 9.48751L9.98284 10.6466C10.2982 10.7798 10.6581 10.5822 10.7158 10.2425L12.3151 0.650033C12.3906 0.201498 11.9086 -0.122691 11.5243 0.0993558Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.42b7328c8f0e962e615f6ec83835d211.svg";
export { ForwardRef as ReactComponent };